function state() {
  return {
    quotation: {},
    quotationList: [],
    quotationListMeta: {},
  };
}

export default state;
